import {SUPER_ADMIN} from "../../../helpers/constants";
import {Button} from "reactstrap";
import {I18n} from "../../../I18n/components/promoter";
import React from "react";
import PromoterCategorySelect from "../PromoterCategory/PromoterCategorySelect";
import CompanySelect from "../../Company/CompanySelect";
import PromoterSectionSelect from "../PromoterSection/PromoterSectionSelect";

const PromoterVideoControls = props => {
    const filterByCompanies = props.authority === SUPER_ADMIN
        ? (
            <CompanySelect
                lang={props.lang}
                companyId={props.companyId}
                companies={props.companies}
                onCompanyChange={props.onCompanyFilterClick}
            />
        )
        : null;

    return (
        <div className="d-md-flex justify-content-between align-items-center">
            <div className="d-md-flex">
                {filterByCompanies}
                <PromoterCategorySelect
                    lang={props.lang}
                    companyIdFilter={props.companyId}
                    onCategoryChange={props.onCategoryFilterClick}
                    categoryId={props.categoryId}
                    categories={props.categories}
                />
                <PromoterSectionSelect
                    lang={props.lang}
                    companyIdFilter={props.companyId}
                    categoryIdFilter={props.categoryId}
                    categories={props.categories}
                    onSectionChange={props.onSectionFilterClick}
                    sectionId={props.sectionId}
                    sections={props.sections}
                />
            </div>
            <div className="font-medium mx-3">
                {I18n[props.lang].totalMemoryUsage} {props.totalMemoryUsage}
            </div>
            <div>
                <Button
                    color="secondary"
                    className="mr-1 mb-1"
                    onClick={props.clearFilters}
                >
                    {I18n[props.lang].resetFilters}
                </Button>
                <Button
                    color="primary"
                    className="mr-1 mb-1"
                    onClick={props.addCategoryClick}
                >
                    {I18n[props.lang].addCategory}
                </Button>
                <Button
                    color="primary"
                    className="mr-1 mb-1"
                    onClick={props.addSectionClick}
                >
                    {I18n[props.lang].addSection}
                </Button>
                <Button
                    color="primary"
                    className="mr-1 mb-1"
                    onClick={props.addVideoClick}
                >
                    {I18n[props.lang].addVideo}
                </Button>
            </div>
        </div>
    )
}

export default PromoterVideoControls;


// WEBPACK FOOTER //
// ./src/components/Promoter/PromoterVideo/PromoterVideoControls.js